import React, { useState, useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { translations } from '../../i18n'
import Loader from '../../components/Loader'

const HONOR_ICONS = ['🏆', '📄', '🎖️', '🥇', '🌟', '📝', '🔬', '💡', '🎓']
const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '')

function HonorsSection() {
  const { lang } = useSelector(s => s.rootReducer.langRed)
  const T = translations[lang]
  const { loading, honors = [] } = useSelector(s => s.rootReducer.honorsRed)
  const [lightbox, setLightbox] = useState(null)

  useEffect(() => {
    if (!lightbox) return
    const onKey = (e) => { if (e.key === 'Escape') setLightbox(null) }
    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [lightbox])

  if (loading) return <section id='honors' className='fc-section'><Container><Loader /></Container></section>

  const field = (item, base) => item[`${base}_${lang}`] || item[`${base}_en`] || ''

  return (
    <section id='honors' className='fc-section'>
      <Container>
        <h2 className='section-title'>{T.sections.honors}</h2>
        <Row className='g-3'>
          {honors.map((h, i) => (
            <Col xs={6} sm={4} md={3} key={h.id}>
              <div
                className={`honor-card${h.image ? ' honor-card-clickable' : ''}`}
                onClick={h.image ? () => setLightbox(h) : undefined}
                role={h.image ? 'button' : undefined}
                tabIndex={h.image ? 0 : undefined}
                onKeyDown={h.image ? (e) => e.key === 'Enter' && setLightbox(h) : undefined}
              >
                {h.image ? (
                  <img
                    src={`${API_BASE}${h.image}`}
                    alt={field(h, 'name')}
                    className='honor-img'
                    onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex' }}
                  />
                ) : null}
                <div className='honor-icon' style={h.image ? { display: 'none' } : {}}>{HONOR_ICONS[i % HONOR_ICONS.length]}</div>
                <div className='honor-name'>{field(h, 'name')}</div>
                {h.year && <div className='honor-year'>{h.year}</div>}
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {lightbox && (
        <div className='lightbox-overlay' onClick={() => setLightbox(null)}>
          <button className='lightbox-close' onClick={() => setLightbox(null)} aria-label='Chiudi'>✕</button>
          <div className='lightbox-content' onClick={e => e.stopPropagation()}>
            <img
              src={`${API_BASE}${lightbox.image}`}
              alt={field(lightbox, 'name')}
              className='lightbox-img'
            />
            <div className='lightbox-caption'>
              <div className='lightbox-title'>{field(lightbox, 'name')}</div>
              {lightbox.year && <div className='lightbox-year-label'>{lightbox.year}</div>}
            </div>
          </div>
        </div>
      )}
    </section>
  )
}

export default HonorsSection
